import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FilterNameText, StyledCompareBar, StyledFilterTag, VerticalBar } from './styled';
import { addSavedFilter, removeFilter, setActiveFilter } from '@store/trends/base/actions';
import { activeFilterIndexSelector } from '@store/trends/base/selectors';
import { COMPARE_LIMIT } from '@store/trends/base/saga';
import { transparentize } from 'polished';
import { filterColors } from '@utils';
import { get } from 'lodash';
import { getFilterName } from '@src/utils/filter/utils';
import SavedFilters from '@src/components/common/Compare/SavedFilters';
import { LineOutlined } from '@ant-design/icons';

const defaultColors = {
  highlight: '#f6f6f6',
  border: '#d9d9d9',
};

function CompareBar({ filters, type }) {
  const dispatch = useDispatch();
  const activeFilter = useSelector(activeFilterIndexSelector);

  const onAddSavedFilter = (filter) => {
    dispatch(addSavedFilter(filter));
  };

  const handleCloseFn = (filter, idx) => () => {
    dispatch(removeFilter(filter, idx));
  };

  const handleFilterClickFn = (filter, idx) => () => {
    dispatch(setActiveFilter(idx));
  };

  const filterTag = (filter, idx) => {
    const isActiveFilter = idx === activeFilter;
    const color = filterColors[idx];

    return (
      <StyledFilterTag
        key={`${filter.name}-${get(filter, ['meta', 'cid'], '-')}-${idx}`}
        closable={!isActiveFilter}
        onClose={handleCloseFn(filter, idx)}
        onClick={handleFilterClickFn(filter, idx)}
        $highlight={isActiveFilter ? transparentize(0.75, color) : defaultColors.highlight}
        style={{ borderColor: isActiveFilter ? color : defaultColors.border }}
      >
        <VerticalBar color={color} />
        <FilterNameText>{getFilterName(filter)}</FilterNameText>
      </StyledFilterTag>
    );
  };

  const filterFragments = filters.map((filter, idx) => filterTag(filter, idx));
  const disableAddBtn = filters.length >= COMPARE_LIMIT;

  return (
    <StyledCompareBar>
      <LineOutlined color="#aaa" />
      {filterFragments}
      <SavedFilters compareFilters={filters} onSelect={onAddSavedFilter} />
    </StyledCompareBar>
  );
}

export default CompareBar;
